import orderBy from 'lodash/orderBy';
import startsWith from 'lodash/startsWith';
import includes from 'lodash/includes';
import ClassCourses from '../components/class-courses';

const isEmpty = str => (!str || str.length === 0);

const retrieveFilterCriteria = (dataFilterOptions) => {
    const lastName = dataFilterOptions.lastNames.find(item => item.selected).key;
    const year = dataFilterOptions.yearGroups.find(item => item.selected).key;
    const classroom = dataFilterOptions.classrooms.find(item => item.selected).key;

    return { lastName, year, classroom, searchTerm: dataFilterOptions.searchTerm };
};

const retrieveTeacherFilterCriteria = (dataFilterOptions) => {
    const lastName = dataFilterOptions.lastNames.find(item => item.selected).key;
    const classroom = dataFilterOptions.classrooms.find(item => item.selected).key;

    return { lastName, classroom, searchTerm: dataFilterOptions.searchTerm };
};

const retrieveClassroomFilterCriteria = (dataFilterOptions) => {
    const year = dataFilterOptions.yearGroups.find(item => item.selected).key;
    const teacher = dataFilterOptions.teachers.find(item => item.selected).data;

    return { year, teacher, searchTerm: dataFilterOptions.searchTerm };
};

const foundInTeachers = (teachersName, term) =>
    teachersName.filter(name => name.toLowerCase().indexOf(term) !== -1).length > 0;

const foundInClassroom = (classList, term) => {
    if (classList.length === 0) {
        return false;
    }

    const filteredClasses = classList.filter(classroom =>
        classroom.name.toLowerCase().indexOf(term) !== -1 ||
        classroom.groupName.toLowerCase().indexOf(term) !== -1 ||
        foundInTeachers(classroom.teachersName, term));

    return filteredClasses.length > 0;
};

const foundInTeacherClassrooms = (classList, term) => {
    if (classList.length === 0) {
        return false;
    }

    const filteredClasses = classList.filter(classroom =>
        classroom.name.toLowerCase().indexOf(term) !== -1);

    return filteredClasses.length > 0;
};

const searchForClassroomTeachers = (teachers, term) => {
    if (teachers.length === 0) {
        return false;
    }

    const filteredClasses = teachers.filter(teacher =>
        teacher.name.toLowerCase().indexOf(term) !== -1);

    return filteredClasses.length > 0;
};

const filterRows = (rows, term) => {
    const filterRowsData = rows.filter(
        (row =>
            row.firstName.toLowerCase().indexOf(term) !== -1 ||
                row.lastName.toLowerCase().indexOf(term) !== -1 ||
                row.password.toLowerCase().indexOf(term) !== -1 ||
                row.userName.toLowerCase().indexOf(term) !== -1 ||
                row.yearGroup.toLowerCase().indexOf(term) !== -1 ||
                foundInClassroom(row.assignedClassrooms, term)
        )
    );
    return filterRowsData;
};

const filterTeacherRows = (rows, term) => {
    const filterRowsData = rows.filter(
        (row =>
            row.title.toLowerCase().indexOf(term) !== -1 ||
                row.firstName.toLowerCase().indexOf(term) !== -1 ||
                row.lastName.toLowerCase().indexOf(term) !== -1 ||
                row.userName.toLowerCase().indexOf(term) !== -1 ||
                row.emailAddress.toLowerCase().indexOf(term) !== -1 ||
                foundInTeacherClassrooms(row.assignedClassrooms, term)
        )
    );
    return filterRowsData;
};

const filterClassRows = (rows, term) => {
    const filterRowsData = rows.filter(
        (row =>
            row.name.toLowerCase().indexOf(term) !== -1 ||
                row.courseTitle.toLowerCase().indexOf(term) !== -1 ||
                row.yearGroupShortName.toLowerCase().indexOf(term) !== -1 ||
                searchForClassroomTeachers(row.teachers, term)
        )
    );
    return filterRowsData;
};

export const sort = (list, propertyName, sortDirection) => orderBy(list, item =>
    (isNaN(item[propertyName]) ? item[propertyName].toLowerCase() : item[propertyName]), sortDirection);

export const filterStudents = (data, dataFilterOptions) => {
    const filterCriteria = retrieveFilterCriteria(dataFilterOptions);
    let filteredData = data || [];
    if (data.length > 0 && filterCriteria) {
        if (!isEmpty(filterCriteria.lastName) && filterCriteria.lastName !== '-1') {
            filteredData = filteredData.filter((item) => {
                if (startsWith(item.lastName.toLowerCase(), filterCriteria.lastName.toLowerCase())) {
                    return true;
                }
                return false;
            });
        }

        const selectedYearGroup = parseInt(filterCriteria.year, 10);
        if (selectedYearGroup !== -1) {
            filteredData = filteredData.filter((item) => {
                if (item.yearGroupEnum === selectedYearGroup) {
                    return true;
                }
                return false;
            });
        }

        if (!isEmpty(filterCriteria.classroom) && filterCriteria.classroom !== '-1') {
            filteredData = filteredData.filter((item) => {
                if (item.assignedClassrooms.length === 0 && filterCriteria.classroom === 'classes') {
                    return true;
                }
                const classes = item.assignedClassrooms.map(classroom => classroom.name);
                if (item.assignedClassrooms.length > 0 && filterCriteria.classroom === 'assignedStudents') {
                    return true;
                }
                return includes(classes, filterCriteria.classroom);
            });
        }

        if (!isEmpty(filterCriteria.searchTerm)) {
            const term = filterCriteria.searchTerm.toLowerCase();
            filteredData = filterRows(filteredData, term);
        }
    }

    return sort(filteredData, dataFilterOptions.sortColumn, dataFilterOptions.sortDirection);
};

export const filterTeachers = (data, dataFilterOptions) => {
    const filterCriteria = retrieveTeacherFilterCriteria(dataFilterOptions);
    let filteredData = data || [];
    if (data.length > 0 && filterCriteria) {
        if (!isEmpty(filterCriteria.lastName) && filterCriteria.lastName !== '-1') {
            filteredData = filteredData.filter((item) => {
                if (startsWith(item.lastName.toLowerCase(), filterCriteria.lastName.toLowerCase())) {
                    return true;
                }
                return false;
            });
        }

        if (!isEmpty(filterCriteria.classroom) && filterCriteria.classroom !== '-1') {
            filteredData = filteredData.filter((item) => {
                if (item.assignedClassrooms.length === 0 && filterCriteria.classroom === 'classes') {
                    return true;
                }
                const classes = item.assignedClassrooms.map(classroom => classroom.name);
                return includes(classes, filterCriteria.classroom);
            });
        }

        if (!isEmpty(filterCriteria.searchTerm)) {
            const term = filterCriteria.searchTerm.toLowerCase();
            filteredData = filterTeacherRows(filteredData, term);
        }
    }

    return sort(filteredData, dataFilterOptions.sortColumn, dataFilterOptions.sortDirection);
};

export const filterClasses = (data, dataFilterOptions) => {
    const filterCriteria = retrieveClassroomFilterCriteria(dataFilterOptions);
    let filteredData = data || [];
    if (data.length > 0 && filterCriteria) {
        const selectedYearGroup = parseInt(filterCriteria.year, 10);
        if (selectedYearGroup !== -1) {
            filteredData = filteredData.filter((item) => {
                if (item.yearGroupEnum === selectedYearGroup) {
                    return true;
                }
                return false;
            });
        }
        if (!isEmpty(filterCriteria.teacher) && filterCriteria.teacher !== '-1') {
            const selectedTeacherProfileId = filterCriteria.teacher.userProfileId;
            filteredData = filteredData.filter((item) => {
                if (item.teachers.length > 0) {
                    const teacherProfileIds = item.teachers.map(teacher => teacher.userProfileId);
                    if (teacherProfileIds.indexOf(selectedTeacherProfileId) !== -1) {
                        return true;
                    }
                }

                return false;
            });
        }

        if (!isEmpty(filterCriteria.searchTerm)) {
            const term = filterCriteria.searchTerm.toLowerCase();
            filteredData = filterClassRows(filteredData, term);
        }
    }

    return sort(filteredData, dataFilterOptions.sortColumn, dataFilterOptions.sortDirection);
};

const renderClassCourses = (classroom, intl) => {
    const currentGroup = classroom.classroomGroups.find(classGroup => classGroup.classroomId === classroom.classroomId);

    const isOptedOut = (currentGroup && currentGroup.isOptedOut) || false;
    return ClassCourses({ ...classroom, yearGroup: classroom.yearGroupEnum, intl, isOptedOut });
};

export const createClassRows = (classes, intl) => classes.map(classroom => ({
    classroomId: classroom.classroomId,
    name: classroom.name,
    yearGroupEnum: classroom.yearGroupEnum.toString(),
    year: classroom.yearGroupShortName.toString(),
    courseTitle: classroom.courseTitle,
    upfCourseTitle: classroom.upfCourseTitle,
    conquestCourseTitle: classroom.conquestCourseTitle,
    courses: renderClassCourses(classroom, intl),
    teachers: classroom.teachers.map(teacher => teacher.name),
    teachersCount: classroom.teachers.length,
    studentsCount: classroom.studentsProfileId.length
}));

export const createTeacherRows = (teachers) => {
    const rows = [];
    teachers.forEach((teacher) => {
        const info = {
            userProfileId: teacher.userProfileId,
            title: teacher.title,
            firstName: teacher.firstName,
            lastName: teacher.lastName,
            emailAddress: teacher.emailAddress,
            emailStatus: teacher.emailStatus,
            userName: teacher.userName,
            password: teacher.password,
            displayTitle: teacher.displayTitle
        };

        let teacherDetail = info;
        const classesCount = teacher.assignedClassrooms.length;
        if (teacher.assignedClassrooms.length > 0) {
            const classes = teacher.assignedClassrooms.map(classroom => classroom.name);
            teacherDetail = { ...info, class: classes, classesCount };
        } else {
            teacherDetail = { ...info, class: '', classesCount };
        }

        rows.push(teacherDetail);
    });

    return rows;
};

export const createRolloverRows = (rolloverItems) => {
    const rows = [];

    rolloverItems.forEach((rowItem) => {
        const info = {
            index: rowItem.index,
            studentFirstName: rowItem.studentFirstName,
            studentLastName: rowItem.studentLastName,
            previousUsername: rowItem.previousUsername,
            year: rowItem.studentYearGroup,
            className: rowItem.classroomName,
            courseTitle: rowItem.courseTitle,
            teacherEmail: rowItem.teacherEmail,
            title: rowItem.teacherTitle,
            teacherFirstName: rowItem.teacherFirstName,
            teacherLastName: rowItem.teacherLastName
        };
        rows.push(info);
    });

    return rows;
};

export const createRolloverSummaryRows = (rolloverSummary, filterType = 'newStudents') => {
    let rows = [];

    switch (filterType) {
    case 'newStudents':
        rolloverSummary.newStudents.forEach((rowItem) => {
            const info = {
                id: rowItem.id,
                firstName: rowItem.firstName,
                surname: rowItem.surname,
                yearGroup: rowItem.yearGroup,
                classroomName: rowItem.classroomName,
                username: rowItem.username,
                password: rowItem.password
            };
            rows.push(info);
        });
        break;

    case 'updatedStudents':
        rolloverSummary.updatedStudents.forEach((rowItem) => {
            const info = {
                id: rowItem.id,
                firstName: rowItem.firstName,
                surname: rowItem.surname,
                yearGroup: rowItem.yearGroup,
                classroomName: rowItem.classroomName,
                username: rowItem.username,
                password: rowItem.password
            };
            rows.push(info);
        });
        break;

    case 'unassignedStudents':
        rolloverSummary.unassignedStudents.forEach((rowItem) => {
            const info = {
                id: rowItem.id,
                firstName: rowItem.firstName,
                surname: rowItem.surname,
                username: rowItem.username,
                password: rowItem.password
            };
            rows.push(info);
        });
        break;

    case 'transferredStudents':
        rolloverSummary.transferredStudents.forEach((rowItem) => {
            const info = {
                id: rowItem.id,
                firstName: rowItem.firstName,
                surname: rowItem.surname,
                yearGroup: rowItem.yearGroup,
                classroomName: rowItem.classroomName,
                username: rowItem.username,
                password: rowItem.password
            };
            rows.push(info);
        });

        break;

    case 'newTeachers':
        rolloverSummary.newTeachers.forEach((rowItem) => {
            const info = {
                id: rowItem.id,
                firstName: rowItem.firstName,
                surname: rowItem.surname,
                title: rowItem.title,
                email: rowItem.email,
                username: rowItem.username
            };
            rows.push(info);
        });
        break;

    case 'updatedTeachers':
        rolloverSummary.updatedTeachers.forEach((rowItem) => {
            const info = {
                id: rowItem.id,
                firstName: rowItem.firstName,
                surname: rowItem.surname,
                title: rowItem.title,
                email: rowItem.email,
                username: rowItem.username
            };
            rows.push(info);
        });
        break;

    case 'newClassrooms':
        rolloverSummary.newClassrooms.forEach((rowItem) => {
            const info = {
                id: rowItem.id,
                classroomName: rowItem.classroomName,
                teacherName: rowItem.teacherName,
                yearGroup: rowItem.yearGroup,
                assignedStudents: rowItem.assignedStudents
            };
            rows.push(info);
        });
        break;

    case 'updatedClassrooms':
        rolloverSummary.updatedClassrooms.forEach((rowItem) => {
            const info = {
                id: rowItem.id,
                classroomName: rowItem.classroomName,
                teacherName: rowItem.teacherName,
                yearGroup: rowItem.yearGroup,
                assignedStudents: rowItem.assignedStudents
            };
            rows.push(info);
        });
        break;

    default:
        rows = [];
        break;
    }

    return rows;
};

export const createRows = (students) => {
    const rows = [];
    students.forEach((student) => {
        const info = {
            userProfileId: student.userProfileId,
            firstName: student.firstName,
            lastName: student.lastName,
            yearGroupEnum: student.yearGroupEnum,
            year: student.yearGroup,
            userName: student.userName,
            password: student.password
        };

        let teachers = '';
        let studentDetail = info;
        const classesCount = student.assignedClassrooms.length;
        if (student.assignedClassrooms.length > 0) {
            const teachersName = [];
            const classes = student.assignedClassrooms.map(data => data.name);
            const groups = student.assignedClassrooms.map(data => data.groupName);
            student.assignedClassrooms.forEach((classroom) => {
                if (classroom.teachersName.length === 0) {
                    teachersName.push('-');
                } else {
                    teachersName.push(classroom.teachersName.join(', '));
                }
            });
            teachers = teachersName;
            studentDetail = { ...info, class: classes, group: groups, teachers, classesCount };
        } else {
            studentDetail = { ...info, class: '', group: '', teachers, classesCount };
        }

        rows.push(studentDetail);
    });

    return rows;
};

export const isListDifferent = (newList, oldList, key) => {
    let idInNewList = [];
    let idInOldLIst = [];

    if (!newList) {
        idInNewList = newList.map(key);
    }

    if (!oldList) {
        idInOldLIst = oldList.map(key);
    }

    if (idInNewList.length !== idInOldLIst.length) {
        return true;
    }

    const nonMatchingIds = idInNewList.filter(id => idInOldLIst.indexOf(id) === -1);
    return nonMatchingIds.length !== 0;
};



// WEBPACK FOOTER //
// ./app/helpers/grid-util.js